const storageName = 'qunatiply-admin-p-storage-1';

export const getComplete = () => {
  if (!localStorage.getItem(storageName)) {
    localStorage.setItem(storageName, JSON.stringify({}));
  }

  return JSON.parse(localStorage.getItem(storageName));
};

export const getItem = (name) => {
  const store = getComplete();

  if (!store[name]) return '';

  return store[name];
};

export const setItems = (list = {}) => {
  // List = { filed: 'value' }
  const store = getComplete();

  const newStore = JSON.stringify(Object.assign({}, store, list));

  localStorage.setItem(storageName, newStore);
};

export const deleteItem = (name) => {
  const store = getComplete();

  if (!store[name]) return;

  delete store[name];

  localStorage.setItem(storageName, JSON.stringify(store));
};

export const clear = () => {
  localStorage.setItem(storageName, JSON.stringify({}));
};

export const deleteComplete = () => {
  localStorage.removeItem(storageName);
};

export const newStorage = (name = '') => {
  const set = (val = '') => {
    setItems({
      [name]: val,
    });
  };

  const get = () => {
    return getItem(name);
  };

  const clear = () => {
    deleteItem(name);
  };

  return {
    set,
    get,
    clear,
  };
};
